import { useState } from "react"
import UserInfoView from "./UserInfoView";
import { NewTabIcon } from "../../../assets/icons";

interface UserModalTriggerProps {
    reservationId?: string;
    orderId?: string;
    id: string;
    name: string;
}

const UserModalTrigger: React.FC<UserModalTriggerProps> = ({ id, name, reservationId, orderId }) => {

    const [isUserInfoViewOpen, setIsUserInfoViewOpen] = useState<boolean>(false);

    return (
        <>
            {isUserInfoViewOpen &&
                <UserInfoView
                    id={id}
                    reservationId={reservationId}
                    orderId={orderId}
                    onClose={() => setIsUserInfoViewOpen(false)}
                />
            }

            <div className="user-modal-trigger-div">
                <div className="user-modal-trigger-text" style={{ color: "black" }}>{name}</div>
                <img src={NewTabIcon} className="icon-size-12 pointer" onClick={() => setIsUserInfoViewOpen(true)} />
            </div>
        </>
    );
};

export default UserModalTrigger;